<!-- page-wrapper Start-->
<div [ngClass]="layout.config.settings.layout_type">
  <div class="page-wrapper" id="canvas-bookmark" [ngClass]="layoutClass">
    <div class="warning-header" *ngIf="loginUserDetails?.organizations[0]?.role?.value == this.roles.Interpreter && !storageService.isProfileComplete">
      <div class="d-flex justify-content-start ms-1 ms-sm-0 flex-wrap flex-sm-nowrap align-items-center h-100">
        <h6 class="mb-0 ms-2 title me-4">{{ "INTERPRETER.INCOMPLETE.PROFILE.HEADER_MESSAGE.TITLE" | translate }}</h6>
        <span class="middle ms-2">{{ "INTERPRETER.INCOMPLETE.PROFILE.HEADER_MESSAGE.SUBTITLE" | translate }}</span>&nbsp;
        <a class="text-decoration-underline ms-1 cursor-pointer end" (click)="navigate()">{{ "INTERPRETER.INCOMPLETE.PROFILE.HEADER_MESSAGE.LABEL.GOTOPROFILE" | translate }}</a>
      </div>
    </div>
      <app-header #headerRef [isIncompleteProfile]="loginUserDetails?.organizations[0]?.role?.value == this.roles.Interpreter && !storageService.isProfileComplete"></app-header>
      <!-- Page Body Start-->
      <div class="page-body-wrapper px-0 ">
        <div class="sidebar-wrapper" [ngClass]="{'showIncompleteProfileDiv':loginUserDetails?.organizations[0]?.role?.value == this.roles.Interpreter && !storageService.isProfileComplete,'hideIncompleteProfileDiv':!(loginUserDetails?.organizations[0]?.role?.value == this.roles.Interpreter && !storageService.isProfileComplete)}" [attr.sidebar-layout]="layout.config.settings.sidebar_type" [attr.icon]="layout.config.settings.icon" [class.close_icon]="navServices.collapseSidebar">
          <app-sidebar [headerComponentRef]="headerRef"></app-sidebar>
        </div>
        <div class="page-body pb-3" [ngClass]="{'showIncompleteProfileDiv':loginUserDetails?.organizations[0]?.role?.value == this.roles.Interpreter && !storageService.isProfileComplete,'hideIncompleteProfileDiv':!(loginUserDetails?.organizations[0]?.role?.value == this.roles.Interpreter && !storageService.isProfileComplete)}">
          <main class="h-100" [@fadeInAnimation]="getRouterOutletState(o)">
            <router-outlet class="h-100" #o="outlet"></router-outlet>
          </main>
        </div>
        <!-- footer start-->
        <!-- <footer class="footer">
          <app-footer></app-footer>
        </footer> -->
        <!-- footer End-->
      </div>
      <!-- Page Body End-->
  </div>
</div>
<div class="bg-overlay1"></div>
<!-- page-wrapper End-->
